import moment from 'moment';
import ScheduledLesson from '@/models/ScheduledLesson';

export const isLessonBeforeToday = (scheduledLesson: ScheduledLesson) =>
  moment(scheduledLesson.datetime, 'YYYY-MM-DD').isBefore(moment());

export const isLessonDelayed = (scheduledLesson: ScheduledLesson) =>
  isLessonBeforeToday(scheduledLesson) && !scheduledLesson.hasDone;
